import windowutils from '../utils/window';
export default class TwitterFeed {
  constructor(el) {
    this.el = el;
    this.twitterid = this.el.dataset.twitterid.replace('@', '');
    this.twitteridarray = this.el.dataset.twitterid
      .replaceAll('@', '')
      .split(',')
      .map((el) => {
        return el.trim();
      });
    this.isgroup = this.twitteridarray.length !== 1;
    this.numberoftweets = this.el.dataset.twittercount;
    this.hasheading = this.el.dataset.heading ? true : false;
    this.feed = `/feeds/twitter/main.html?screenname=${this.twitterid}&count=${this.numberoftweets}`;
    /*this.getdata().then((response)=>{
            this.data = response;
            this.appendfeed();
            this.addheader();
            this.clickhandler();
        });*/
    // this.addheader();
    //this.getFeeds(this.twitteridarray);
    this.tempFix();
  }

  getFeeds(handles) {
    try {
      if (this.isgroup) {
        const promises = handles.map((handle) =>
          fetch(
            `/feeds/twitter/main.html?screenname=${handle}&count=${this.numberoftweets}`
          )
        );
        Promise.all(promises)
          .then((responses) => Promise.all(responses.map((r) => r.json())))
          .then((data) => {
            this.data = data;
            this.appendfeed(data);
            this.clickhandler();
            this.addheader();
          });
      } else {
        handles.map((handle) => {
          fetch(
            `/feeds/twitter/main.html?screenname=${handle}&count=${this.numberoftweets}`
          )
            .then((response) => response.json())
            .then((data) => {
              this.data = data;
              this.appendfeed(data);
              this.clickhandler();
              this.addheader();
            });
        });
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  appendfeed(data) {
    const tweets = data.flat(1);
    const tweetsbydate = tweets.sort((a, b) => {
      return +Date.parse(b.created_at) - +Date.parse(a.created_at);
    });
    let feedul = document.createElement('ul');
    let hastweets = false;
    tweetsbydate.forEach((item, index) => {
      if (index < this.numberoftweets) {
        feedul.insertAdjacentHTML(
          'beforeend',
          `
                <li>
                    <a href="https://www.twitter.com/${item.user.id}/status/${item.id_str}" target="blank">
                        ${this.isgroup ? `<strong>${item.user.screen_name}</strong> ` : ''}${item.text}
                    </a>
                </li>`
        );
        hastweets = true;
      }
    });
    hastweets ? this.el.insertAdjacentElement('beforeend', feedul) : null;
  }

  addheader() {
    let header = '';
    if (!this.isgroup) {
      header = `
            <a href="https://www.twitter.com/${this.twitterid}" target="blank">
                <img class="twitter_profile_pic" width="48" height="48" alt="${this.data[0].user.name} icon" src="${this.data[0].user.profile_image_url_https}" />
                ${this.hasheading ? `<h2 style="text-wrap:normal">${this.el.dataset.heading}</h2>` : `<h2 style="text-wrap:normal">${this.data[0].user.name} on Twitter</h2>`}
            </a>
        `;
    } else {
      header = this.hasheading
        ? `<h2 style="text-wrap:normal">${this.el.dataset.heading}</h2>`
        : `<h2 style="text-wrap:normal">Group tweets</h2>`;
      const tweetbox = document.querySelector('.twitter_tweet');
      const tweetlink = document.querySelector('.twitter_link');
      tweetbox.parentNode.removeChild(tweetbox);
      tweetlink.parentNode.removeChild(tweetlink);
    }
    this.el.insertAdjacentHTML('afterbegin', header);
  }

  clickhandler() {
    if (this.el.nextElementSibling.classList.contains('twitter_tweet')) {
      this.el.nextElementSibling.addEventListener('click', (e) => {
        window.open(
          'https://twitter.com/intent/tweet?text=%40' + this.twitterid,
          '',
          'width=650, height=270'
        );
      });
    }
  }

  tempFix() {
    console.log(
      this.el.parentNode.parentNode.classList.contains('contentPanel')
    );
    const isstaff =
      this.el.parentNode.parentNode.classList.contains('contentPanel');
    let twitterlink = `<a class="twitter-timeline" data-height="400" href="https://twitter.com/${this.twitterid}">Tweets by ${this.twitterid}</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`;
    if (isstaff) {
      twitterlink = `<p class="calltoaction cobalt x"><a href="https://twitter.com/${this.twitterid}">Follow @${this.twitterid}</p></li></ul>`;
    }
    this.el.insertAdjacentHTML('beforebegin', twitterlink);
    windowutils.injectScript('https://platform.twitter.com/widgets.js');
    this.el.nextElementSibling.style.display = 'none';
    this.el.nextElementSibling.nextElementSibling.style.display = 'none';
    this.el.style.display = 'none';
  }
}
